import React, { Component } from 'react'
import { connect } from 'react-redux'
import ButtonWithoutLoader from 'UI/ButtonWithoutLoader'
import axios from 'axios'
import { ExcelUploadColumns } from 'Constants'

import * as FileSaver from "file-saver";
import * as XLSX from 'xlsx';
import { Workbook } from 'exceljs/dist/exceljs';
import classNames from "classnames";
import { path } from 'Constants'
import { addANIDDetails, } from 'actions/spendActions'

class UploadANID extends Component {
  constructor(props) {
    super(props)
    this.state = {
      csvFile: '',
      columns: [],
      data: [],
      responseMsg: '',
      excelData: [],
      isSaveInProgress: false,
    }

  }  

  handleDownload() {
    this.setState({ isSaveInProgress: true }, this.downloadANIDSampleFile)
  }

  downloadANIDSampleFile() {
    axios.get(path + 'ANID_BPID.xlsx', {
      responseType: 'blob', // Ensure that the response is in binary form (Blob)
    })
      .then((response) => {
        // Create a link element
        const link = document.createElement('a');

        // Create a URL for the Blob
        const url = window.URL.createObjectURL(new Blob([response.data]));

        // Set the download attribute with the filename
        link.href = url;
        link.setAttribute('download', 'ANID.xlsx'); // Specify the name of the downloaded file

        // Append the link to the document and trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.setState({ isSaveInProgress: false });
      })
      .catch((error) => {
        console.error('There was an error downloading the file', error);
      });
  }

  handleChange(e) {
    const files = e.target.files;
    if (files && files[0]) this.setState({ file: files[0], responseMsg: '', isError: 'No', isLoading: false, isSaveInProgress: false }, this.handleFile);
  }

  handleFile() {
    this.setState({ responseMsg: "" })
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, { defval: "" });
      this.setState({ excelData: data })
    }
    reader.readAsBinaryString(this.state.file);
  }



  handleSubmit = (e) => {

    let rowData = this.state.excelData;

    if (rowData.length == 0) {
      this.setState({ responseMsg: 'No Records found', isError: 'Yes', isLoading: false, isSaveInProgress: false })
      return;
    }

    this.setState({ isLoading: true, isSaveInProgress: true })
    var inputParam = []
    rowData.forEach((values) => {

      let obj = {}
      obj.SRID = String(values.SRID).trim()
      obj.CUSTOMER_NAME = String(values.CUSTOMER_NAME).trim()
      obj.BPID = String(values.BPID).trim()
      obj.BUYER_ANID = String(values.BUYER_ANID).trim()
      obj.SAP_REGION = String(values.SAP_REGION).trim()
      obj.COUNTRY = String(values.COUNTRY).trim()
      obj.RECORD_STATUS = "File Loaded"
      obj.RECORD_FLAG = 'Y'
      obj.USER_ID = this.props.user.user.Email;
      inputParam.push(obj)
    })

    this.props.addANIDDetails(inputParam)
      .then((response) => {
        this.props.reloadGrid();
        this.setState({ responseMsg: 'Record/s has been updated successfully', isError: 'No', isLoading: false, isSaveInProgress: false })

      }).catch((error) => {
        this.setState({ responseMsg: this.props.content.error, isError: 'Yes', isLoading: false, isSaveInProgress: false })
      })
  }

  render() {
    return (
      <div style={{ padding: '30px' }}>
        <div>
          {(this.state.isSaveInProgress) ?
            <img style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
              src={path + `images/ajax-loader.gif`} alt="" />
            : null
          }
        </div>

        <div className="grid-x grid-padding-x">
          <div className="medium-12 popHeader">Upload ANID Details</div>
        </div>
        <br></br>
        <div className="grid-x grid-padding-x pt10">

          <div className="medium-4"><ButtonWithoutLoader
            type='submit'
            content={this.props.content.downloadBtn}
            onClick={(e) => this.handleDownload(e)}
            color
          /></div>

          <div className="medium-5 pt10" style={{ float: 'right' }}>
            <input
              type="file"
              style={{ display: 'block' }}
              accept='.xlsx, .xls'
              id='csvFile'
              onChange={(e) => this.handleChange(e)}
            />
          </div>

          <div className="medium-3" style={{ float: 'left' }}>
            <ButtonWithoutLoader
              type='submit'
              content={this.props.content.uploadBtn}
              color
              onClick={this.handleSubmit.bind(this)}
              className={classNames('float-right',
                {
                  'hand-cursor': this.state.isLoading ? false : true,
                  'gray-scale': this.state.isLoading ? true : false
                })}
              disabled={this.state.isLoading ? true : false}
            />
          </div>

        </div>

        <br></br>
        <div className="grid-x grid-padding-x" style={{ color: (this.state.isError === "Yes") ? 'red' : 'green' }}>{this.state.responseMsg}</div>
      </div>
    )
  }

}

const mapStateToProps = state => {
  return {
    userData: state.valueStory,
    user: state.default,
    validation: state.content.validation,
    spendDetails: state.spendDetails,
    content: state.content.spendAnalysis.detailedFile,
    exchangeMastcontent: state.content.exchange,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    addANIDDetails: (formValues) => dispatch(addANIDDetails(formValues))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadANID)